import { BaseCriteria } from "../../support/base-criteria.model";

export class GetCurrentEmployeeItemInfoModel extends BaseCriteria {

  public ItemId: number;
}

